<template>
  <v-container fluid grid-list-sm>
    <!-- Filtro -->
    <div>
      <v-card
        class="pl-2 pr-2"
        style="min-width: 100% !important; display: flex !important"
      >
        <!-- <v-select
          outlined
          label="Contexto"
          append-icon="mdi-arrow-down"
          :items="contextos"
          itemid="id"
          item-value="id"
          item-text="valor"
          style="max-width: 200px !important;margin-right:20px;"
          v-model="contexto"
          return-object
        >
        </v-select> -->

        <v-select
          outlined
          label="Período"
          append-icon="mdi-arrow-down"
          :items="filtros"
          itemid="id"
          item-value="id"
          item-text="valor"
          style="max-width: 200px !important"
          v-on:change="setCamposPesquisa()"
          v-model="periodoFixo"
          return-object
        >
        </v-select>

        <input
          v-model="dataInicial"
          type="date"
          :class="
            periodoFixo.id == 5 ? 'Visivel DashInputs' : 'Invisivel DashInputs'
          "
          placeholder=""
        />
        <input
          v-model="dataFinal"
          type="date"
          :class="
            periodoFixo.id == 5 ? 'Visivel DashInputs' : 'Invisivel DashInputs'
          "
          placeholder=""
        />
        <v-btn
          v-if="btnhabilitado"
          @click="consultarDados()"
          small
          color="primary"
          class="ml-2"
          style="
            color: white;
            min-height: 40px;
            font-weight: bold;
            margin-top: 10px;
          "
        >
          <v-icon
            class="pr-1"
            small
            color="white"
            @click="() => consultarDados()"
            >mdi-magnify</v-icon
          >
          Pesquisar
        </v-btn>
        <v-btn
          v-else
          @click="consultarDados()"
          small
          color="primary"
          class="ml-2"
          disabled
          style="
            color: white;
            min-height: 40px;
            font-weight: bold;
            margin-top: 10px;
          "
        >
          <v-icon
            class="pr-1"
            small
            color="white"
            @click="() => consultarDados()"
            >mdi-magnify</v-icon
          >
          Pesquisar Novamente Após 10 segundos
        </v-btn>
        <v-spacer></v-spacer>
        <!-- <v-btn
          v-if="btnhabilitado"
          @click="emailNotifyMensal()"
          class="ml-2"
          style="
            color: white;
            min-height: 40px;
            font-weight: bold;
            margin-top: 10px;
          "
          color="red"
        >
          <v-icon>mdi-file-pdf</v-icon> PDF</v-btn
        > -->
      </v-card>
    </div>
    <!-- Cards -->
    <v-row>
      <v-layout wrap style="display: flex; justify-content: center">
        <CardDashBoard
          v-if="
            dadosCheckinRealizado &&
            dadosCheckinRealizado.dados &&
            dadosCheckinRealizado.dados.length > 0
          "
          cor="green"
          icone="mdi-login"
          :titulo="dadosCheckinRealizado.titulo"
          :valor="dadosCheckinRealizado.dados[0].qtde"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosCheckinRealizado.titulo"
          :tagTitle="`Quantidade de Reservas no Status check in com data de check in entre ${dataInicialFormatada} e ${dataFinalFormatada} `"
          
        />

        <CardDashBoard
          v-if="
            dadosCheckoutRealizado &&
            dadosCheckoutRealizado.dados &&
            dadosCheckoutRealizado.dados.length > 0
          "
          cor="red"
          icone="mdi-logout"
          :titulo="dadosCheckoutRealizado.titulo"
          :valor="dadosCheckoutRealizado.dados[0].qtde"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosCheckoutRealizado.titulo"
          :tagTitle="`Quantidade de Reservas no Status check out com data de check out entre ${dataInicialFormatada} e ${dataFinalFormatada}`"
        />

        <CardDashBoard
          v-if="
            dadosReservasNoShow &&
            dadosReservasNoShow.dados &&
            dadosReservasNoShow.dados.length > 0
          "
          cor="orange"
          icone="mdi-login"
          :titulo="dadosReservasNoShow.titulo"
          :valor="dadosReservasNoShow.dados[0].qtde"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosReservasNoShow.titulo"
          :tagTitle="`Quantidade de Reservas no Status No Show com data de check in entre ${dataInicialFormatada} e ${dataFinalFormatada}`"
        />

        <CardDashBoard
          v-if="
            dadosReservasConfirmadas &&
            dadosReservasConfirmadas.dados &&
            dadosReservasConfirmadas.dados.length > 0
          "
          cor="blue"
          icone="mdi-login"
          :titulo="dadosReservasConfirmadas.titulo"
          :valor="dadosReservasConfirmadas.dados[0].qtde"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosReservasConfirmadas.titulo"
          :tagTitle="`Quantidade de Reservas no Status Confirmada com data de check in entre ${dataInicialFormatada} e ${dataFinalFormatada}`"
        />

        <CardDashBoard
          v-if="
            dadosWebcheckinpreenchidosrealizados &&
            dadosWebcheckinpreenchidosrealizados.dados &&
            dadosWebcheckinpreenchidosrealizados.dados.length > 0
          "
          cor="#9e10c1"
          icone="mdi-login"
          :titulo="dadosWebcheckinpreenchidosrealizados.titulo"
          :valor="dadosWebcheckinpreenchidosrealizados.dados[0].qtde"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosWebcheckinpreenchidosrealizados.titulo"
          :tagTitle="`Quantidade de Web Checkins Realizados / Web Checkins Enviados com data de check in entre ${dataInicialFormatada} e ${dataFinalFormatada}`"
        />

        <CardDashBoard
          v-if="dadosOcupacao && dadosOcupacao.titulo"
          cor="#9e10c1"
          icone="mdi-login"
          :titulo="dadosOcupacao.titulo"
          :valor="dadosOcupacao.qtde"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosOcupacao.titulo"
          :tagTitle="`Percentual de Ocupação entre os dias ${dataInicialFormatada} e ${dataFinalFormatada}`"
        />

        <CardDashBoard
          v-if="
            dadosFichasPreenchidasPendentes &&
            dadosFichasPreenchidasPendentes.dados &&
            dadosFichasPreenchidasPendentes.dados.length > 0
          "
          cor="orange"
          icone="mdi-account-edit"
          :titulo="dadosFichasPreenchidasPendentes.titulo"
          :valor="dadosFichasPreenchidasPendentes.dados[0].qtde"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosFichasPreenchidasPendentes.subtitulo"
          :tagTitle="`Quantidades de Fichas (Hospedes) com data de check in entre os dias ${dataInicialFormatada} e ${dataFinalFormatada} que estão completamente Preenchidas mas NÃO foram enviadas ao PMS `"
        />

        <CardDashBoard
          v-if="
            dadosFichasPreenchidasFinalizadas &&
            dadosFichasPreenchidasFinalizadas.dados &&
            dadosFichasPreenchidasFinalizadas.dados.length > 0
          "
          cor="green"
          icone="mdi-account-edit"
          :titulo="dadosFichasPreenchidasFinalizadas.titulo"
          :valor="dadosFichasPreenchidasFinalizadas.dados[0].qtde"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosFichasPreenchidasFinalizadas.subtitulo"
          :tagTitle="`Quantidades de Fichas (Hospedes) com data de check in entre os dias ${dataInicialFormatada} e ${dataFinalFormatada} que estão completamente Preenchidas e foram enviadas ao PMS COM SUCESSO.`"
        />

        <CardDashBoard
          v-if="
            dadosTempoPreenchimentoManual &&
            dadosTempoPreenchimentoManual.dados &&
            dadosTempoPreenchimentoManual.dados.length > 0
          "
          cor="red"
          icone="mdi-account-edit"
          :titulo="dadosTempoPreenchimentoManual.titulo"
          :valor="dadosTempoPreenchimentoManual.dados[0].tempo"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosTempoPreenchimentoManual.subtitulo"
          :tagTitle="`Tempo médio do Preenchimento Manual da Ficha.`"
        />

        <CardDashBoard
          v-if="
            dadosTempoPreenchimentoWebcheckin &&
            dadosTempoPreenchimentoWebcheckin.dados &&
            dadosTempoPreenchimentoWebcheckin.dados.length > 0
          "
          cor="indigo"
          icone="mdi-account-edit"
          :titulo="dadosTempoPreenchimentoWebcheckin.titulo"
          :valor="dadosTempoPreenchimentoWebcheckin.dados[0].tempo"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosTempoPreenchimentoWebcheckin.subtitulo"
          :tagTitle="`Tempo Médio do Preenchimento do Web Checkin.`"
        />

        <CardDashBoard
          v-if="Object.keys(dadosLeads).length > 0"
          cor="green"
          icone="mdi-account-group-outline"
          :titulo="dadosLeads.titulo + ' Emails/Fones'"
          :valor="dadosLeads.emails + '/' + dadosLeads.fones"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosLeads.subtitulo"
          :tagTitle="`Quantidades de Emails e Telefones capturados dos Hospedes com data de check in entre os dias ${dataInicialFormatada} e ${dataFinalFormatada}.`"
          :downloadData="dadosLeads.leaddata"
        />

        <CardDashBoard
          v-if="
            dadosReservasImportadas &&
            Object.keys(dadosReservasImportadas).length > 0
          "
          cor="blue"
          icone="mdi-account-details"
          :titulo="dadosReservasImportadas.titulo"
          :valor="dadosReservasImportadas.total"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosReservasImportadas.subtitulo"
          :tagTitle="`Quantidades de Reservas importadas em qualquer STATUS e com data de check in entre os dias ${dataInicialFormatada} e ${dataFinalFormatada}.`"
        />
       
        <CardDashBoard
          v-if="Object.keys(dadosHospedesNaCasa).length > 0"
          cor="blue"
          icone="mdi-account-details"
          :titulo="dadosHospedesNaCasa.titulo"
          :valor="dadosHospedesNaCasa.total"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosHospedesNaCasa.subtitulo"
          :tagTitle="(((dataInicialFormatada == dataFinalFormatada) && dataInicialFormatada == hoje ) ? 
                      `Quantidade de Hospedes com Status check in que estão dentro da casa`
                      :`Quantidade de Hospedes com Status ( confirmada, check in ou check out) que passaram da casa entre os dias ${dataInicialFormatada} e ${dataFinalFormatada}`) "
        />

        <CardDashBoard
          v-if="Object.keys(dadosTempoFD).length > 0"
          cor="green"
          icone="mdi-clock"
          :titulo="dadosTempoFD.titulo"
          :valor="dadosTempoFD.dados[0].tempo + 'min'"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosTempoFD.subtitulo"
          :tagTitle="`Tempo médio do preenchimento completo da ficha de todos os hospedes com data de checkin entre os dias ${dataInicialFormatada} e ${dataFinalFormatada}.`"
        />

        <!-- <CardDashBoard
          v-if="Object.keys(dadosRobo).length > 0"
          :cor="dadosRobo.subtitulo == 'ATIVADO' ? '#33ca3f' : 'black'"
          :icone="dadosRobo.subtitulo == 'ATIVADO' ? 'mdi-robot' : 'mdi-robot-off'"
          :titulo="dadosRobo.titulo"
          :valor="''"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosRobo.subtitulo"
          :tagTitle="dadosRobo.titulo"
        /> -->
        <!-- AQUI NOVO CARD -->
        <CardDashBoard
          v-if="
            dadosFichasPreenchidasFinalizadas &&
            dadosFichasPreenchidasFinalizadas.dados &&
            dadosFichasPreenchidasFinalizadas.dados.length > 0
          "
          cor="green"
          icone="mdi-cash-plus"
          titulo="Economia FD"
          :valor="'R$ ' + Math.round((dadosFichasPreenchidasFinalizadas.dados[0].qtde*2)* 0.6)"
          iconesecundario="mdi-cash"
          :titulosecundario="
            'Aprox. ' +
            dadosFichasPreenchidasFinalizadas.dados[0].qtde * 2 +
            ' papéis NÃO impressos'
          "
          :tagTitle="dadosTempoFD.titulo"
        />
      </v-layout>
    </v-row>
    <!-- <v-dialog v-model="dialog" width="90%">
      <v-card>
        <v-toolbar> Aqui </v-toolbar>
      </v-card>
    </v-dialog> -->
    <!-- Gráficos -->
    <v-row>
      <v-layout wrap style="display: flex; justify-content: center">
        <BarCardDashboard
          v-if="dadosFaixaEtaria"
          cor="green"
          :titulo="dadosFaixaEtaria.titulo"
          :titulosecundario="dadosFaixaEtaria.subtitulo"
          :data="dadosFaixaEtaria.data"
          :options="dadosFaixaEtaria.options"
          iconesecundario="mdi-calendar"
        />

        <BarCardDashboard
          v-if="dadosTipoPensao"
          cor="blue"
          :titulo="dadosTipoPensao.titulo"
          :titulosecundario="dadosTipoPensao.subtitulo"
          :data="dadosTipoPensao.data"
          :options="dadosTipoPensao.options"
          iconesecundario="mdi-calendar"
        />

        <BarCardDashboard
          v-if="dadosEmpresaReservante"
          cor="red"
          :titulo="dadosEmpresaReservante.titulo"
          :titulosecundario="dadosEmpresaReservante.subtitulo"
          :data="dadosEmpresaReservante.data"
          :options="dadosEmpresaReservante.options"
          iconesecundario="mdi-calendar"
        />

        <BarCardDashboard
          v-if="dadosGenero && dadosGenero.data"
          cor="orange"
          :titulo="dadosGenero.titulo"
          :titulosecundario="dadosGenero.subtitulo"
          :data="dadosGenero.data"
          :options="dadosGenero.options"
          iconesecundario="mdi-calendar"
        />

        <BarCardDashboard
          v-if="
            dadosRankingvelocidadeoperadores &&
            dadosRankingvelocidadeoperadores.data &&
            dadosRankingvelocidadeoperadores.data.series[0].length > 0
          "
          cor="green"
          :options="{chartPadding:{top:30}}"
          :titulo="dadosRankingvelocidadeoperadores.titulo"
          :data="dadosRankingvelocidadeoperadores.data"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosRankingvelocidadeoperadores.subtitulo"
        />

        <BarCardDashboard
          v-if="
            dadosOcupacaoProxSeteDias &&
            dadosOcupacaoProxSeteDias.dados &&
            dadosOcupacaoProxSeteDias.dados.series[0].length > 0
          "
          :options="{chartPadding:{top:30}}"
          cor="green"
          :titulo="dadosOcupacaoProxSeteDias.titulo"
          :data="dadosOcupacaoProxSeteDias.dados"
          iconesecundario="mdi-calendar"
          :titulosecundario="dadosOcupacaoProxSeteDias.subtitulo"
        />

        <!-- GRAFICO DE BARRA DE EXEMPLO -->
        <!-- <BarCardDashboard cor="green" :titulo="dadoExemplo.titulo" :data="dadosFaixaEtaria.data"
                          iconesecundario="mdi-calendar" :titulosecundario="dadoExemplo.subtitulo" /> -->

        <!-- <PieCardDashboard v-if="dadosGeneroPizza && dadosGeneroPizza.data"
          cor="light green" :titulo="dadosGeneroPizza.titulo" 
          :titulosecundario="dadosGeneroPizza.subtitulo"
          :data="dadosGeneroPizza.data"
          iconesecundario="mdi-calendar" 
        /> -->
      </v-layout>
    </v-row>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import CardDashBoard from "./CardDashBoard";
import BarCardDashboard from "./BarCardDashboard.vue";

import jsPDF from "jspdf";

//import PieCardDashboard from './PieCardDashboard.vue'
export default {
  name: "Dashboard",
  components: {
    CardDashBoard,
    BarCardDashboard,
    //PieCardDashboard
  },
  data() {
    let data = new Date();
    let mm = "";
    let dd = "";
    if (data.getMonth() < 10) {
      mm = "0" + (data.getMonth() + 1);
    } else {
      mm = data.getMonth() + 1;
    }

    if (data.getDate() < 10) {
      dd = "0" + data.getDate();
    } else {
      dd = data.getDate();
    }

    return {
      hoje: null,
      intervalorVerificarRobo: null,
      btnhabilitado: true,
      //dialog: false,
      contextos:[
        { id: "1", valor: "Data Checkin" },
        { id: "2", valor: "Data Cadastro" }
      ],
      contexto: { id: "1", valor: "Data Checkin" },
      filtros: [
        { id: "1", valor: "Hoje" },
        {
          id: 2,
          valor: "Ultimos 7 dias",
        },
        {
          id: 3,
          valor: "Ultimos 15 dias",
        },
        {
          id: 4,
          valor: "Ultimos 30 dias",
        },
        {
          id: 5,
          valor: "Personalizado",
        },
      ],
      periodoFixo: { id: "1", valor: "Hoje" },
      dataInicial: null,
      dataFinal: null,
      dadosDash: null,
      searchHospede: "",
      percocupacao: "",
      uhsocupadas: "",
      uhspool: "",
      dataini: data.getFullYear() + "-" + mm + "-" + dd,
      datafim: data.getFullYear() + "-" + mm + "-" + dd,

      datainiReservas: data.getFullYear() + "-" + mm + "-" + dd,
      datafimReservas: data.getFullYear() + "-" + mm + "-" + dd,

      descstatusreserva: "Confirmada",

      totalhospedes: "",
      totalmensagens: 0,
      medianotamensagens: 0,

      empresareservante: [],
      tipopensao: [],
      tipohospede: [],

      tab: 0,

      headersUHs: [
        {
          text: "UH",
          align: "start",
          filterable: true,
          width: "10px",
          value: "coduh",
        },
        { text: "Status GOV", value: "descstatusgov", width: "100px" },
        { text: "Status UH", value: "descstatusuh", width: "100px" },
      ],
      uhs: [],
      /*
      fim do cód
      */
      dadoExemplo: {
        data: {
          labels: ["0-2", "3-11", "12-17", "18-59", ">60"],
          series: [[15, 26, 19, 300, 10]],
        },
        titulo: "Titulo Teste",
        subtitulo: "Dia Atual",
      },
      dadosFaixaEtaria: null,
      dadosEmpresaReservante: null,
      dadosTipoPensao: null,
      dadosGenero: null,
      dadosGeneroPizza: null,
      dadosHospedesPorTipo: null,
      dadosHospedesPorEmpresaReservante: null,
      dailySalesChart: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          contGraph: 5,
          low: 0,
          high: 110, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      dataCompletedTasksChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      tipoHospedeCharts: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },
        options: {
          axisX: {
            showGrid: false,
          },
          contGraph: 5,
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 768x)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      headers: [
        { text: "UH", value: "coduh", width: "100px" },
        { text: "Nº Reserva", value: "numreserva", width: "100px" },
        { text: "Nome", value: "nome", width: "80px" },
        { text: "Sobrenome", value: "sobrenome", width: "80px" },
        { text: "Principal", value: "hospedeprincipaltxt", width: "80px" },
        { text: "Cliente", value: "empresareservante", width: "200px" },
        { text: "Tipo de Hóspede", value: "tipohospede", width: "150px" },
        { text: "Pensão", value: "pensao", width: "100px" },
        { text: "Check-IN", value: "datacheckin", width: "150px" },
        { text: "Check-OUT", value: "datacheckout", width: "150px" },
      ],
      items: [],
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false,
      },
      headersReservas: [
        { text: "UH", value: "coduh", width: "100px" },
        { text: "Nº Reserva", value: "numreserva", width: "100px" },
        { text: "Nome", value: "nome", width: "80px" },
        { text: "Sobrenome", value: "sobrenome", width: "80px" },
        { text: "Principal", value: "hospedeprincipaltxt", width: "80px" },
        { text: "Cliente", value: "empresareservante", width: "200px" },
        { text: "Tipo de Hóspede", value: "tipohospede", width: "150px" },
        { text: "Pensão", value: "pensao", width: "100px" },
        { text: "Check-IN", value: "datacheckin", width: "150px" },
        { text: "Check-OUT", value: "datacheckout", width: "150px" },
      ],
      itemsReservas: [],
      dadosCheckinRealizado: {},
      dadosCheckoutRealizado: {},
      dadosReservasNoShow: {},
      dadosReservasConfirmadas: {},
      dadosFichasPreenchidasPendentes: {},
      dadosFichasPreenchidasFinalizadas: {},
      dadosTempoPreenchimentoManual: {},
      dadosTempoPreenchimentoWebcheckin: {},
      dadosWebcheckinpreenchidosrealizados: {},
      dadosRankingvelocidadeoperadores: {},
      dadosOcupacaoProxSeteDias: {},
      dadosOcupacao: {},
      dadosLeads: {},
      dadosRobo: { titulo: "Robô", subtitulo: "DESLIGADO", qtde: "" },
      dadosReservasImportadas: {},
      dadosHospedesNaCasa: {},
      dadosTempoFD: {},
    };
  },
  methods: {
    createPDF() {
      let pdfName = "FichaDigital";
      var doc = new jsPDF();
      var imgdata =
        "data:image/png;base64,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";
      doc.addImage(imgdata, "PNG", 15, 40, 100, 100);
      doc.text("Hello World", 50, 10);
      doc.text("Hello World2", 10, 20);
      doc.save(pdfName + ".pdf");
    },
    async emailNotifyMensal() { 
      let body = {
        assunto: "Ficha Digital - Suas Economias",
        destinatario: "savio.mauricio@gmail.com",
        html: this.html('Envio Email Estatisticas'),
      };
     
      //console.log(body);
      let hoje = new Date

       console.log(hoje.getDate()+ ' e '+ hoje.getHours())


      // if (hoje.getDate() == 1 && hoje.getHours() == 7) {
        await this.$http
          .post("/email/enviaremaileconomiafd", body)
          .then((response) => {
            if (response.status == 200) {
              console.log("Ok, Email enviado");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      // }else{
      //   console.log("Fora do Horário");
      // }
    },
    html(){
      return `<!DOCTYPE HTML
    PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
    xmlns:o="urn:schemas-microsoft-com:office:office">

    <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="x-apple-disable-message-reformatting">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link
      href="https://fonts.googleapis.com/css2?family=Pragati+Narrow:wght@400;700&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,900&display=swap"
      rel="stylesheet">
    <title>Email</title>

    <style type="text/css">
      * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
      }

      body {
        background-color: #f6f9fc;
      }

      table {
        border-spacing: 0;
      }

      td {
        padding: 0;
      }

      .wrapper {
        width: 100%;
        table-layout: fixed;
        background-color: #f6f9fc;
        padding-bottom: 2em;
      }

      .webkit {
        max-width: 600px;
        background-color: #fff;
      }

      .outer {
        margin: 0 auto;
        width: 100%;
        max-width: 600px;
        border-spacing: 0;
        font-family: Roboto;
        color: #4a4a4a
      }

      @media screen and (max-width: 600px) {}

      @media screen and (max-width: 400px) {}
    </style>
    </head>

    <body>
    <center class="wrapper">
      <div class="webkit">
        <table class="outer" align="center">
          <tr>
            <td>
              <table width="100%">
                <tr>
                  <td style="
                    background:linear-gradient(#02AFDB, #0F88F2);
                    padding: 2em;
                    text-align: center;
                    color: white;
                    text-transform: uppercase;
                    letter-spacing: .02em;
                    ">
                    <h1>Ficha Digital</h1>
                  </td>
                </tr>
              </table>
            </td>
          </tr>


          <tr>
            <td>
              <table width="100%" style="border-spacing: 0;padding:2em">

                <tr>
                  <td>
                    <table width="100%" style="border-spacing: 0;">
                      <tr>
                        <td style="font-size: 24px;
                        font-weight: bold;
                        letter-spacing:.02em;
                        padding: 0 1em 1em 0;text-align:center;">
                         Estatísticas do Sistema
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td>
                    <table width="100%" style="border-spacing: 0;">
                      <tr>
                        <td>
                          <h4>Quantidade de Paginas Economizadas: ${this.dadosFichasPreenchidasFinalizadas.dados[0].qtde * 2 } Páginas.</h4><br/>
                          <h4>Valor Economia em Papeis, impressos e custos: ${"R$ " + this.dadosFichasPreenchidasFinalizadas.dados[0].qtde * 0.49} </h4><br/>
                          <h4>Checkins realizados: ${this.dadosCheckinRealizado.dados[0].qtde}</h4><br/>
                          <h4>Checkouts Realizados: ${this.dadosCheckoutRealizado.dados[0].qtde}</h4><br/>
                          <h4>Reservas No-Show: ${this.dadosReservasNoShow.dados[0].qtde}</h4><br/>
                          <h4>Reservas Confirmadas: ${this.dadosReservasConfirmadas.dados[0].qtde}</h4><br/>
                          <h4>Fichas Finalizadas: ${this.dadosFichasPreenchidasFinalizadas.dados[0].qtde }</h4><br/>
                          <h4>Tempo Médio Manual: ${this.dadosTempoPreenchimentoManual.dados[0].tempo}</h4><br/>
                          <h4>Tempo WebCheckin: ${this.dadosTempoPreenchimentoWebcheckin.dados[0].tempo}</h4><br/>
                          <h4>Tempo FD: ${this.dadosTempoFD.dados[0].tempo + "min"}</h4><br/>
                          <h4>Leads Coletados: ${this.dadosLeads.emails + " / " + this.dadosLeads.fones} | Emails/Fones</h4><br/>
                          <h4>Reservas Importadas: ${this.dadosReservasImportadas.total}</h4><br/>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- <tr>
                  <td style="padding: 1em 0;">
                    <button type="button" style="padding: 1em 2em;
                    width: 15em;
                    border-radius: 2em;
                    border: none;
                    background-color: #0F88F2;
                    border: inner 4px solid #fff;
                    color: #fff;
                    font-size: 1em;
                    font-weight: bold;
                    text-transform: uppercase;
                    ">
                      ação
                    </button>
                  </td>
                </tr> -->
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table width="100%" style="border-spacing: 0;">
                <tr>
                  <td style="
                  background: linear-gradient(#02AFDB, #0F88F2);
                  padding: 1em;
                  text-align: center;
                  ">
                    <p style="font-size: 18px; 
                    margin-bottom:.5em;
                    font-weight: bold;
                    color:#fff;">
                      Faça contato com a gente
                    </p>
                    <img style="width:36px;" src="/img/white-youtube.png" />
                    <img style="width:36px;" src="/img/white-linkedin.png" />
                    <img style="width:36px;" src="/img/white-twitter.png" />
                    <img style="width:36px;" src="/img/white-facebook.png" />
                    <img style="width:36px;" src="/img/white-instagram.png" />
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table width="100%" style="border-spacing: 0;">
                <tr style="background-color: #efefef">
                  <td style="
                    padding: 2em;
                    text-align: center;
                    padding-bottom: 1em;
                    ">
                    <h1 style="
                    text-transform: uppercase;
                    letter-spacing: .02em;
                    color: #0F88F2; margin-bottom:.5em;">Ficha Digital</h1>
                    <p style="font-size: 12px; color: #4a4a4a;margin-bottom: .5em;">
                      Rua 123, Natal, Rio Grande do Norte
                    </p>
                    <p style="font-size: 12px; color: #0F88F2;margin-bottom: .2em;">
                      economysoftware@mail.com
                    </p>
                    <p style="font-size: 12px; color: #0F88F2;margin-bottom: .5em;">
                      +5599999999
                    </p>
                  </td>
                </tr>
                <tr>
                  <td height="20" style="background-color: #0F88F2"></td>
                </tr>
              </table>
            </td>

          </tr>

        </table>
      </div>
    </center>
    </body>

    </html>`
    },
    checkinRealizados() {
      let dados = {
        tipo: "checkinsrealizados",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosCheckinRealizado = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkoutsrealizados() {
      let dados = {
        tipo: "checkoutsrealizados",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosCheckoutRealizado = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reservasNoShow() {
      let dados = {
        tipo: "reservasnoshow",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosReservasNoShow = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reservasconfirmadas() {
      let dados = {
        tipo: "reservasconfirmadas",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosReservasConfirmadas = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fichaspreenchidaspendentes() {
      let dados = {
        tipo: "fichaspreenchidaspendentes",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosFichasPreenchidasPendentes = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fichaspreenchidasfinalizadas() {
      let dados = {
        tipo: "fichaspreenchidasfinalizadas",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosFichasPreenchidasFinalizadas = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    tempopreenchimentomanual() {
      let dados = {
        tipo: "preenchimentomanual",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosTempoPreenchimentoManual = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    tempopreenchimentowebcheckin() {
      let dados = {
        tipo: "preenchimentowebcheckin",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosTempoPreenchimentoWebcheckin = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    webcheckinpreenchidosrealizados() {
      let dados = {
        tipo: "webcheckinpreenchidosrealizados",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosWebcheckinpreenchidosrealizados = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    roboOcupacao() {
      let dados = {
        tipo: "ocupacao",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
        usuario: localStorage.getItem("useremail"),
        tipocard: "simples",
      };
      this.$http.post("/dashboard/robo/buscarDados", dados);
      // .then(resp => { this.dadosWebcheckinpreenchidosrealizados = resp.data})
    },
    roboOcupacaoBarra() {
      let dados = {
        tipo: "ocupacao",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
        usuario: localStorage.getItem("useremail"),
        tipocard: "barra",
      };
      this.$http.post("/dashboard/robo/buscarDados", dados);
      // .then(resp => { this.dadosWebcheckinpreenchidosrealizados = resp.data})
    },
    graficofaixaetaria() {
      let dados = {
        tipo: "faixaetaria",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          console.log(resp.data);

          this.dadosFaixaEtaria = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    graficoempresareservante() {
      let dados = {
        tipo: "empresareservante",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          console.log(resp.data);
          this.dadosEmpresaReservante = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    graficotipopensao() {
      let dados = {
        tipo: "tipopensao",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          console.log(resp.data);
          this.dadosTipoPensao = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    graficogenero() {
      let dados = {
        tipo: "genero",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          console.log(resp.data);
          this.dadosGenero = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    graficogeneropizza() {
      let dados = {
        tipo: "genero",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          console.log(resp.data);
          this.dadosGeneroPizza = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
      // .then(resp => { this.dadosWebcheckinpreenchidosrealizados = resp.data})
      // .catch(error =>{  alert(error) })
    },
    rankingvelocidadeoperadores() {
      let dados = {
        tipo: "rankingvelocidadeoperadores",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscarDados", dados)
        .then((resp) => {
          this.dadosRankingvelocidadeoperadores = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    consultaTempoFD() {
      let dados = {
        tipo: "tempomediofd",
        dtinicial: this.dataInicial,
        dtfinal: this.dataFinal,
        idhotel: localStorage.getItem("hotel"),
      };
      this.$http
        .post("/dashboard/buscardados", dados)
        .then((resp) => {
          this.dadosTempoFD = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });

      // this.$http.post("/dashboard/buscardados",
      // { dtinicial: this.dataini, dtfinal: this.datafim, idhotel : localStorage.getItem('hotel') , tipo : "consultatempofd" })
      //   .then((response) => {
      //     this.dadosTempoFD = response.data;

      //     console.log(this.dataini)

      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   })
    },
    consultarDados() {
      this.dadosCheckinRealizado = {};
      this.dadosCheckoutRealizado = {};
      this.dadosReservasNoShow = {};
      this.dadosReservasConfirmadas = {};
      this.dadosFichasPreenchidasPendentes = {};
      this.dadosFichasPreenchidasFinalizadas = {};
      this.dadosTempoPreenchimentoManual = {};
      this.dadosWebcheckinpreenchidosrealizados = {};
      this.dadosRankingvelocidadeoperadores = {};
      this.dadosOcupacao = {};
      this.dadosRobo = { titulo: "Robô", subtitulo: "DESLIGADO", qtde: "" };
      this.dadosLeads = {};
      this.dadosReservasImportadas = {};
      this.dadosHospedesNaCasa = {};
      this.dadosTempoFD = {};
      this.btnhabilitado = false;
      setTimeout(() => {
        this.btnhabilitado = true;
      }, 10000);

      // alert(this.periodoFixo)
      if (!this.consultarDados) {
        alert("Informe um Periodo");
        return false;
      }

      if (this.periodoFixo.id == 5 && (!this.dataInicial || !this.dataFinal)) {
        alert("Informe um Periodo válido");
        return false;
      }

      if (this.periodoFixo.id == 1) {
        this.dataInicial = dayjs().format("YYYY-MM-DD");
        this.dataFinal = dayjs().format("YYYY-MM-DD");
      }

      if (this.periodoFixo.id == 2) {
        this.dataInicial = dayjs().subtract(6, "day").format("YYYY-MM-DD");
        this.dataFinal = dayjs().format("YYYY-MM-DD");
      }

      if (this.periodoFixo.id == 3) {
        this.dataInicial = dayjs().subtract(14, "day").format("YYYY-MM-DD");
        this.dataFinal = dayjs().format("YYYY-MM-DD");
      }

      if (this.periodoFixo.id == 4) {
        this.dataInicial = dayjs().subtract(29, "day").format("YYYY-MM-DD");
        this.dataFinal = dayjs().format("YYYY-MM-DD");
      }


      this.dataInicialFormatada = dayjs(this.dataInicial).format("DD/MM/YYYY")
      this.dataFinalFormatada = dayjs(this.dataFinal).format("DD/MM/YYYY")
      
      this.checkinRealizados();
      this.checkoutsrealizados();
      this.reservasNoShow();
      this.reservasconfirmadas();
      this.webcheckinpreenchidosrealizados();
      this.roboOcupacao();
      this.roboOcupacaoBarra();
      this.rankingvelocidadeoperadores();
      this.graficofaixaetaria();
      this.graficotipopensao();
      this.graficogenero();
      this.graficogeneropizza();
      this.graficoempresareservante();
      this.fichaspreenchidaspendentes();
      this.fichaspreenchidasfinalizadas();

      this.tempopreenchimentomanual();
      this.tempopreenchimentowebcheckin();
      this.buscaLeads();
      this.buscaReservasImportadas();
      this.buscaHospedesNaCasa();
      this.consultaTempoFD();
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },
    loaduhData() {
      this.$http("/dashboard/consultauhs")
        .then((response) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.uhs = response.data;
            } else {
              this.uhs = [];
            }
          } else {
            this.uhs = [];
          }
        })
        .catch((error) => {
          console.log(error);
          return;
        });
    },
    consultaOcupacao() {
      this.$http("/dashboard/consultaocupacao")
        .then((response) => {
          this.uhspool = response.data.uhspool;
          this.uhsocupadas = response.data.uhsocupadas;
          this.percocupacao = (this.uhsocupadas * 100) / this.uhspool;
          this.percocupacao = parseFloat(this.percocupacao).toFixed(1);
        })
        .catch((error) => console.log(error));
    },
    consultaFaleconosco() {
      this.$http("/portal/buscamensagens", {
        params: { dataini: this.dataini, datafim: this.datafim },
      })
        .then((response) => {
          this.totalmensagens = response.data.total;
          this.medianotamensagens =
            parseFloat(response.data.media).toFixed(1) || 0;
        })
        .catch((error) => console.log(error));
    },
    consultaTotalHospedes() {
      this.$http("/dashboard/buscatotalhospedes", {
        params: { dataini: this.dataini, datafim: this.datafim },
      })
        .then((response) => {
          this.totalhospedes = response.data.totalhospedes;
        })
        .catch((error) => console.log(error));
    },
    consultaHospedesCheckin() {
      this.$http("/ocupacao/hospedesnacasa", {
        params: { dataini: this.dataini, datafim: this.datafim },
      })
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => console.log(error));
    },
    buscaReservas() {
      this.$http("/pms/buscareservas", {
        params: {
          dataini: this.datainiReservas,
          datafim: this.datafimReservas,
          descstatusreserva: this.descstatusreserva,
        },
      })
        .then((response) => {
          this.itemsReservas = response.data;
        })
        .catch((error) => console.log(error));
    },
    consultaOcupacaoAnalitico() {
      this.$http("/ocupacao/ocupacaoanalitico", {
        params: { dataini: this.dataini, datafim: this.datafim },
      })
        .then((response) => {
          this.tipopensao = response.data["tipopensao"];

          let tp = 0;
          for (tp = 0; tp < response.data["tipopensao"].length; tp++) {
            this.dailySalesChart.data.labels.push(
              response.data["tipopensao"][tp].pensao
            );
            this.dailySalesChart.data.series[0].push(
              response.data["tipopensao"][tp].totalpensao
            );
          }

          this.dailySalesChart.options.high =
            Math.max.apply(null, this.dailySalesChart.data.series[0]) + 50;

          this.tipohospede = response.data["tipohospede"];

          let th = 0;
          for (th = 0; th < this.tipoHospedeCharts.options.contGraph; th++) {
            this.tipoHospedeCharts.data.labels.push(
              response.data["tipohospede"][th].tipohospede
            );
            this.tipoHospedeCharts.data.series[0].push(
              response.data["tipohospede"][th].totaltipohospede
            );
          }
          this.tipoHospedeCharts.options.high =
            Math.max.apply(null, this.tipoHospedeCharts.data.series[0]) + 50;

          this.empresareservante = response.data["empresareservante"];
        })
        .catch((error) => console.log(error));
    },
    buscaLeads() {
      this.$http
        .post("/dashboard/buscardados", {
          dtinicial: this.dataInicial,
          dtfinal: this.dataFinal,
          idhotel: localStorage.getItem("hotel"),
          tipo: "buscaleads",
        })
        .then((response) => {
          this.dadosLeads = response.data;
          //console.error(this.dadosLeads)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    buscaReservasImportadas() {
      this.$http
        .post("/dashboard/buscardados", {
          dtinicial: this.dataInicial,
          dtfinal: this.dataFinal,
          idhotel: localStorage.getItem("hotel"),
          tipo: "reservasimportadas",
        })
        .then((response) => {
          this.dadosReservasImportadas = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    buscaHospedesNaCasa() {
      this.$http
        .post("/dashboard/buscardados", {
          dtinicial: this.dataInicial,
          dtfinal: this.dataFinal,
          idhotel: localStorage.getItem("hotel"),
          tipo: "hospedesnacasa",
        })
        .then((response) => {
          this.dadosHospedesNaCasa = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    verificarRobo() {
      // if (this.dadosRobo.subtitulo == "...") {
        // this.dadosRobo = {
        //   titulo: "Robô",
        //   subtitulo: "Desligado",
        //   qtde: "",
        // };
      this.dadosRobo.subtitulo = "Desligado";
      // } else {
      //   this.dadosRobo = {
      //     titulo: "Robô",
      //     subtitulo: "...",
      //     qtde: "",
      //   };
      // }
      this.$socket.emit("dash_to_backend_verificar_robo", {
        hotel: localStorage.getItem("idhotelpms"),
        email: localStorage.getItem("useremail"),
      });
    },
  },
  beforeMount() {
    this.consultarDados();
  },
  // beforeDestroy() {
  //   this.sockets.unsubscribe("backend_to_dash_atualizar_dashboard_geral");
  //   clearInterval(this.intervalorVerificarRobo);
  // },
  mounted() {
    this.hoje = dayjs().format('DD/MM/YYYY')
    //this.buscaLeads()
    //Conexao Socket
    this.$socket.disconnect();
    this.$socket.io.opts.query.usuario = localStorage.getItem("useremail");
    this.$socket.io.opts.query.tipo = "DASHBOARD";
    this.$socket.io.opts.query.tipo_acesso = "DASHBOARD";
    this.$socket.connect();
    // this.$store.dispatch("setHiddenDrawer", true)
    this.sockets.unsubscribe("backend_to_dash_atualizar_dashboard");
    this.sockets.subscribe("backend_to_dash_atualizar_dashboard", (dados) => {
      //  alert(JSON.stringify(dados))
      if (dados.tipo == "ocupacao") {
        if (dados.PERC) {
          this.dadosOcupacao = {
            titulo: "Ocupação",
            subtitulos: "",
            qtde: dados.PERC + "% ",
          };
        } else {
          let objetoAux = {
            titulo: "Ocupação Próximos 7 dias",
            subtitulo: "Ocupação Próximos 7 dias",
            dados: {
              series: [dados.dados.series],
              labels: dados.dados.labels,
            },
          };

          this.dadosOcupacaoProxSeteDias = objetoAux;
        }
      }
      // alert("aa"+dados. ativo)
      if (dados.tipo == "verificaRobo") {
        //console.error(JSON.stringify(dados))
        this.dadosRobo = {
          titulo: "Robô",
          subtitulo: dados.ativo == true ? "ATIVADO" : "DESLIGADO",
          qtde: "",
        };
      }
    });

    this.sockets.unsubscribe("backend_to_dash_atualizar_dashboard_geral");
    this.sockets.subscribe("backend_to_dash_atualizar_dashboard_geral", () => {
      this.consultarDados();
    });

    // this.intervalorVerificarRobo = setInterval(() => {
    //   this.verificarRobo();
    // }, 5000);


  // setInterval(this.emailNotifyMensal(), 65000);


    /*     this.consultaOcupacao();

    this.consultaFaleconosco();

    this.consultaTotalHospedes();

    this.consultaHospedesCheckin();

    this.consultaOcupacaoAnalitico();

    this.buscaReservas();

    this.loaduhData();

    setInterval(() => {
      this.consultaOcupacao();

      this.consultaFaleconosco();

      this.consultaTotalHospedes();
    }, 60000);

    //conecta dashboard ao socket do ficha
    this.$socket.disconnect();
    this.$socket.io.opts.query.usuario = localStorage.getItem('useremail')
    this.$socket.io.opts.query.tipo = 'DASHBOARD'
    this.$socket.io.opts.query.tipo_acesso = 'DASHBOARD'
    this.$socket.connect();

    }, 60000); */
  },
};
</script>

<style scoped>
.v-card__text {
  background-color: red !important;
  margin-top: 50px;
}

.DashInputs {
  /* background-color: red; */
  width: 250px;
  min-height: 40px !important;
  border-radius: 5px;
  padding: 5px;
  border: solid 1px #bdbdbd;
  margin-left: 10px;
}

.DashBtn {
  margin-left: 10px;
  width: 20%;
  background-color: #2196f3 !important;
  color: white !important;
  font-weight: bold;
}

.Visivel {
  display: inline !important;
  width: 180px !important;
  height: 20px;
  margin-top: 10px;
}

.Invisivel {
  display: none !important;
}
</style>

